import { Template } from "../template"
import { Point } from "./point"

let FLAG = 0
const FLAGS = [
  {
    title: "The 6-Color Pride Flag",
    dots: 5,
    colors: [
      { size: 1 / 6, color: "#ed2225" },
      { size: 1 / 6, color: "#f99621" },
      { size: 1 / 6, color: "#f1eb1b" },
      { size: 1 / 6, color: "#0c9b49" },
      { size: 1 / 6, color: "#3954a5" },
      { size: 1 / 6, color: "#93298e" },
    ],
  },
  {
    title: "The Pride Flag",
    dots: 5,
    colors: [
      { size: 1 / 8, color: "#f66fb4" },
      { size: 1 / 8, color: "#f51110" },
      { size: 1 / 8, color: "#f18d11" },
      { size: 1 / 8, color: "#f1f212" },
      { size: 1 / 8, color: "#118d11" },
      { size: 1 / 8, color: "#12babb" },
      { size: 1 / 8, color: "#461298" },
      { size: 1 / 8, color: "#8d118d" },
    ],
  },
  {
    title: "The Transgender Flag",
    dots: 5,
    colors: [
      { size: 1 / 5, color: "#5bcefa" },
      { size: 1 / 5, color: "#f5a8b8" },
      { size: 1 / 5, color: "#fefefe" },
      { size: 1 / 5, color: "#f5a8b8" },
      { size: 1 / 5, color: "#5bcefa" },
    ],
  },
  {
    title: "The Bisexual Pride Flag",
    dots: 5,
    colors: [
      { size: 2 / 5, color: "#ff4495" },
      { size: 1 / 5, color: "#b43ee8" },
      { size: 2 / 5, color: "#395eb9" },
    ],
  },
  {
    title: "The Nonbinary Pride Flag",
    dots: 5,
    colors: [
      { size: 1 / 4, color: "#fdf32f" },
      { size: 1 / 4, color: "#fefefe" },
      { size: 1 / 4, color: "#9c58d1" },
      { size: 1 / 4, color: "#000000" },
    ],
  },
  {
    title: "The flag for the Lesbian Community",
    dots: 5,
    colors: [
      { size: 1 / 7, color: "#d52d00" },
      { size: 1 / 7, color: "#ef7627" },
      { size: 1 / 7, color: "#ff9b57" },
      { size: 1 / 7, color: "#ffffff" },
      { size: 1 / 7, color: "#d162a4" },
      { size: 1 / 7, color: "#b55690" },
      { size: 1 / 7, color: "#a30262" },
    ],
  },
  {
    title: "The Gay Man Pride Flag",
    dots: 5,
    colors: [
      { size: 1 / 7, color: "#078e70" },
      { size: 1 / 7, color: "#26ceaa" },
      { size: 1 / 7, color: "#98e8c1" },
      { size: 1 / 7, color: "#f2efff" },
      { size: 1 / 7, color: "#7bade2" },
      { size: 1 / 7, color: "#5049cb" },
      { size: 1 / 7, color: "#3d1a78" },
    ],
  },
]

class Flag extends Template {
  constructor() {
    const args = [
      "\n%c %c %c %c %c %c %cby @andrevenancio%cexclusive for hicetnunc.xyz\n",
      "background: #ed2225; padding: 4px;",
      "background: #f99621; padding: 4px;",
      "background: #f1eb1b; padding: 4px;",
      "background: #0c9b49; padding: 4px;",
      "background: #3954a5; padding: 4px;",
      "background: #93298e; padding: 4px;",
      "background: #000000; color: #00ffff; font-size: x-small;padding: 4px;",
      "background: transparent; color: #999999; font-size: x-small;padding: 4px;",
    ]

    super({ ratio: 1, args })
  }

  setup() {
    window.addEventListener("keyup", (e) => {
      if (e.key === "c") {
        FLAG++
        this.buildFlag()
      }
    })
    const canvas = document.createElement("canvas")
    document.body.appendChild(canvas)

    this.context = canvas.getContext("2d")

    // 23rd April 2021
    this.friction = 0.95
    this.spring = 0.04
  }

  buildFlag() {
    this.dots = FLAGS[FLAG % FLAGS.length].dots
    this.minDist = this.width / this.dots - 1

    this.points = []

    // stripes
    let y = 0
    const f = FLAG % FLAGS.length
    for (let c = 0; c < FLAGS[f].colors.length; c++) {
      const height = this.height * FLAGS[f].colors[c].size
      const color = FLAGS[f].colors[c].color

      // dots
      for (let i = 0; i < this.dots; i++) {
        const x = (this.width / (this.dots - 2)) * i
        const p = new Point(x, y, height, color)
        this.points.push(p)
      }

      y += height
    }
  }

  resize(width, height, ratio) {
    this.context.canvas.width = width * ratio
    this.context.canvas.height = height * ratio
    this.context.canvas.style.width = `${width}px`
    this.context.canvas.style.height = `${height}px`

    this.buildFlag()
  }

  update() {
    this.context.clearRect(
      0,
      0,
      this.context.canvas.width,
      this.context.canvas.height
    )

    // move dots
    for (let i = 0; i < this.points.length; i++) {
      this.points[i].vy +=
        (this.points[i].restY - this.points[i].y) * this.spring

      if (this.mouse.down) {
        const dx = this.mouse.x - this.points[i].x
        const dy = this.mouse.y - this.points[i].restY
        const dist = Math.sqrt(dx * dx + (dy / 2) * (dy / 2))
        // const dist = Math.sqrt(dx * dx + dy * dy)
        if (dist < this.minDist) {
          this.points[i].vy += (this.mouse.y - this.points[i].y) * this.spring
        }
      }

      this.points[i].vy *= this.friction
      this.points[i].y += this.points[i].vy
    }

    // draw
    for (let i = 0; i < this.points.length; i += this.dots) {
      this.context.beginPath()
      this.context.fillStyle = this.points[i].color
      this.context.moveTo(this.points[i + 0].x, this.points[i + 0].y)
      for (let j = 0; j < this.dots - 1; j++) {
        const cx = (this.points[i + j].x + this.points[i + j + 1].x) * 0.5
        const cy = (this.points[i + j].y + this.points[i + j + 1].y) * 0.5
        this.context.quadraticCurveTo(
          this.points[i + j].x,
          this.points[i + j].y,
          cx,
          cy
        )
      }
      this.context.lineTo(this.width, this.height)
      this.context.lineTo(0, this.height)
      this.context.lineTo(0, this.points[0].y)
      this.context.fill()
    }
  }
}

const app = new Flag()
